import { Badge } from "@/components/ui/badge";
import { Roles } from '@/types/auth/auth';

export const getRoleBadgeColor = (role: string | null) => {
  switch (role) {
    case Roles.Admin:
      return "bg-purple-100 text-purple-800";
    case Roles.Business:
      return "bg-blue-100 text-blue-800";
    case Roles.Consumer:
      return "bg-green-100 text-green-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const getRoleLabel = (role: string | null) => {
  switch (role) {
    case Roles.Admin:
      return "Admin";
    case Roles.Business:
      return "Business";
    case Roles.Consumer:
      return "Consumer";
    default:
      return role || "Unknown";
  }
};

export const getSubscriptionStatusBadge = (status: string | null | undefined) => {
  if (!status) {
    return <Badge variant="outline" className="text-xs">None</Badge>;
  }

  switch (status) {
    case "active":
      return <Badge className="bg-green-100 text-green-800 text-xs">Active</Badge>;
    case "trialing":
      return <Badge className="bg-blue-100 text-blue-800 text-xs">Trial</Badge>;
    case "canceled":
      return <Badge variant="outline" className="text-xs text-gray-600">Canceled</Badge>;
    case "past_due":
      return <Badge className="bg-yellow-100 text-yellow-800 text-xs">Past Due</Badge>;
    case "incomplete":
      return <Badge className="bg-orange-100 text-orange-800 text-xs">Incomplete</Badge>;
    default:
      return <Badge variant="outline" className="text-xs">{status}</Badge>;
  }
};
